import { gql } from '@apollo/client';

export const ALL_COUNTRIES = gql`
  query getCountries($input: NameSearchArgs!) {
    countries: getCountries(input: $input) {
      id
      name
    }
  }
`;
